const LEGACY_ICON_ALIASES = {
  grid: 'grid-2x2',
  tool: 'hammer',
  shield: 'shield',
  bolt: 'zap',
  grill: 'cooking-pot',
  flame: 'flame',
  gift: 'gift'
};

function normalizeLucideIconName(value) {
  if (!value) return '';

  const normalized = String(value)
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-{2,}/g, '-');

  return LEGACY_ICON_ALIASES[normalized] || normalized;
}

function markLucideIcons(root = document) {
  const icons = root.querySelectorAll('[data-lucide-icon-key]:not([data-lucide])');

  icons.forEach((icon) => {
    const iconName = normalizeLucideIconName(icon.dataset.lucideIconKey);
    if (!iconName) return;

    icon.setAttribute('data-lucide', iconName);
  });
}

function renderLucideIcons(root = document) {
  markLucideIcons(root);

  if (!window.lucide || typeof window.lucide.createIcons !== 'function') {
    return;
  }

  window.lucide.createIcons({
    attrs: {
      width: '32',
      height: '32',
      'stroke-width': '2',
      'aria-hidden': 'true'
    },
    nameAttr: 'data-lucide'
  });
}

window.BrikampLucideIcons = {
  normalize: normalizeLucideIconName,
  render: renderLucideIcons
};

document.addEventListener('DOMContentLoaded', () => {
  renderLucideIcons(document);
});

document.addEventListener('shopify:section:load', (event) => {
  renderLucideIcons(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  renderLucideIcons(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  renderLucideIcons(event.target);
});

document.addEventListener('shopify:block:load', (event) => {
  renderLucideIcons(event.target);
});
